import { render } from "./TopBar.vue?vue&type=template&id=0a5a65a0"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=0a5a65a0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__